import Button from "@/components/button/Button";
import {usePublicUserContext} from "@/components/context/hooks.ts";
import {REQUEST_DEMO} from "@/lib/featureFlags.ts";
import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";

import styles from "./ContentHeaderButton.module.scss";

interface ContentHeaderButtonProps {
  tryButtonClass?: string;
  demoButtonClass?: string;
  containerClass?: string;
}

export const ContentHeaderButton = ({tryButtonClass, demoButtonClass, containerClass}: ContentHeaderButtonProps) => {
  const {userHasFeature} = usePublicUserContext();
  return (
    <div className={`${styles.buttonRow} ${containerClass ?? ""} d-flex align-items-center`}>
      <Button
        variant="marketingPrimary"
        size="marketingLarge"
        as={"a"}
        className={`${tryButtonClass}`}
        href={`${URL_ORIGINAL_WEBSITE}/accounts/register`}
      >
        Get Started
      </Button>
      {userHasFeature(REQUEST_DEMO) && (
        <Button
          variant="marketingSecondary"
          size="marketingLarge"
          as={"a"}
          className={demoButtonClass ?? ""}
          href={`${URL_ORIGINAL_WEBSITE}/request-demo`}
        >
          Request a Demo
        </Button>
      )}
    </div>
  );
};
